import React, { useState, useEffect } from 'react';
import { Menu, Button, message } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined, UserOutlined, TeamOutlined, LogoutOutlined, TrophyOutlined } from '@ant-design/icons';
import UserProfileAPI from '../services/UserProfileAPI';
import type { MenuProps } from 'antd';

const Navbar: React.FC = () => {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    // Equivalent to componentDidMount
    UserProfileAPI.authenticateRequests();
    // Check if the user is logged in by verifying the presence of the token
    const token = localStorage.getItem('atilaToken');
    const atilaUser = localStorage.getItem('atilaUser');
    const username = atilaUser ? JSON.parse(atilaUser).user_profile.username : null;
    setUsername(username);
    console.log('Navbar useEffect');

    setIsLoggedIn(!!token);
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleLogout = () => {
    try {
      // Clear user session (e.g., remove token from localStorage)
      localStorage.removeItem('atilaToken');
      localStorage.removeItem('atilaUser');
      message.success('Logged out successfully');
      setIsLoggedIn(false);
    } catch (error) {
      message.error('Failed to log out');
    }
  };

  const items: MenuProps['items'] = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: <Link to="/">Home</Link>,
    },
    {
      key: '/mentorship',
      icon: <TeamOutlined />,
      label: <Link to="/mentorship">Mentors</Link>,
    },
    {
      key: '/scholarship',
      icon: <TrophyOutlined />,
      label: <Link to="/scholarship">Scholarships</Link>,
    },
    ...(isLoggedIn ? [
      {
        key: '/profile',
        icon: <UserOutlined />,
        label: <Link to={`/profile/${username}`}>Profile</Link>,
      },
      {
        key: '/logout',
        icon: <LogoutOutlined />,
        label: (
          <a onClick={handleLogout}>
            Logout
          </a>
        ),
      }
    ] : [
      {
        key: '/login',
        icon: <UserOutlined />,
        label: <Link to="/login">Login</Link>,
      }
    ])
  ];
  
  return (
    <nav className="navbar">
      <Menu
        mode="horizontal"
        selectedKeys={[location.pathname]}
        items={items}
        className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md"
      />
    </nav>
  );
};

export default Navbar;